export default function Footer() {
  return (
    <footer className="bg-[#0a0a0a] text-white py-12 border-t border-white/10 relative overflow-hidden">
      {/* Subtle background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[300px] h-[150px] bg-[#f15700] opacity-[0.05] blur-[100px] pointer-events-none"></div>
      
      <div className="container max-w-6xl mx-auto px-6 relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <h3 className="text-2xl font-bold flex items-center justify-center md:justify-start gap-2">
              <span className="text-[#f15700]">Sashank</span> Pilli
            </h3>
            <p className="text-sm text-gray-400 mt-1">Full Stack Developer</p>
          </div>
          <div className="flex space-x-6 text-sm font-medium">
            <a href="#home" className="text-gray-400 hover:text-[#f15700] transition-colors">
              Home
            </a>
            <a href="#projects" className="text-gray-400 hover:text-[#f15700] transition-colors">
              Portfolio
            </a>
            <a href="#contact" className="text-gray-400 hover:text-[#f15700] transition-colors">
              Contact
            </a>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-white/5 flex flex-col items-center justify-center gap-4 text-sm text-gray-500">
          <div>
            &copy; {new Date().getFullYear()} All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
